import { SelectField } from '@/components/form';
import { useDistributors } from '@/data/hooks';

/**
 * "Distribuidor" selector for a customer (admin only: listing distributors is an admin/finance read, so render it
 * only for them). Choosing one makes the customer a sub-account of that distributor, who then sees its account,
 * invoices and payments; "Sin distribuidor" leaves it unlinked.
 */
export function DistributorField({ value, onChange }: { value: string; onChange: (distributorId: string) => void }) {
  const query = useDistributors({ limit: 100 });
  // "Sin distribuidor" is a real choice (it removes the link), not a disabled placeholder.
  const options = [
    { value: '', label: 'Sin distribuidor' },
    ...(query.data?.items ?? []).map((d) => ({ value: d.distributorId, label: d.name })),
  ];

  return (
    <SelectField
      label="Distribuidor"
      options={options}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      hint="Si es subcliente de un distribuidor, elígelo aquí. El distribuidor verá su cuenta, facturas y pagos."
    />
  );
}
